Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "settings2";
exports.labelBodyText = "settings2 Body";

exports.btnExampleTitle = "CLICK ME";

exports.TOKEN = "token"
exports.httpGetMethod = "GET"
exports.httpPatchMethod = "PATCH"
exports.toggle2faApiEndpoint = "bx_block_settings/settings/toggle_two_factor"
exports.settingsDetailsApiEndpoint = "bx_block_settings/settings"
exports.updateAccountApiEndpoint = "bx_block_settings/settings/update_account_profile"
exports.notificationApiEndpoint = "bx_block_settings/settings/update_notification";
exports.updateEmailApiEndpoint = "bx_block_settings/settings/update_account_email";
exports.otpVerificationEndpoint = "bx_block_settings/settings/verify_email_otp";
exports.sendPhonOtpApiEndPoint = "bx_block_settings/settings/send_phone_update_code";
exports.verifyPhonOtpApiEndPoint = "bx_block_settings/settings/verify_and_update_phone_number";
exports.updatePasswordEndpoint = "bx_block_settings/settings/update_password";
// Customizable Area End